import createApiClient from "./createApiClient";

const apiClient = createApiClient();

export default apiClient;
